import React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import { formatPercentage, DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import CreditCardShape from '../definitions/CreditCardShape';
import getInterestAndMinimumIncomeColumns from '../functions/getInterestAndMinimumIncomeColumns';
import CardFooter from './CardFooter';


function CardFooterLowInterest({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    // leave the second column empty if this LI card does not have a promotional offer attached
    const hasPromoInfo = typeof cardInfo.balanceTransferPromoInterest === 'number' && cardInfo.balanceTransferPromoMonths;

    const columns = [
        null,

        hasPromoInfo
            ? intl.formatMessage(COMMON_MESSAGES.cardFooterBalanceTransferOffer, {
                ...DefaultIntlFormatValues,
                balanceTransferPromoRateFormatted: formatPercentage(cardInfo.balanceTransferPromoInterest, intl),
                balanceTransferPromoMonths: cardInfo.balanceTransferPromoMonths,
            })
            : null,

        ...getInterestAndMinimumIncomeColumns({
            purchaseInterest: cardInfo.purchaseInterest,
            cashAdvanceInterest: cardInfo.cashAdvanceInterest,
            balanceTransferInterest: cardInfo.balanceTransferInterest,

            minimumIncome: cardInfo.minimumIncome,
            minimumCreditScore: cardInfo.minimumCreditScore,
            intl,
        }),
    ];

    return (
        <CardFooter
            columns={columns}
            {...otherProps}
        />
    );
}

CardFooterLowInterest.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};


export default observer(CardFooterLowInterest);
